import { render, staticRenderFns } from "./summary_field.vue?vue&type=template&id=60595118&scoped=true&"
import script from "./summary_field.vue?vue&type=script&lang=js&"
export * from "./summary_field.vue?vue&type=script&lang=js&"
import style0 from "./summary_field.vue?vue&type=style&index=0&id=60595118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60595118",
  null
  
)

export default component.exports